/* eslint-disable no-nested-ternary */
import React, { Fragment, useState, useContext } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SettingsIcon from '@material-ui/icons/Settings';
import { IconButton } from '@material-ui/core';
import { PNCounterIcon } from '@mummssoftware/global-context/PNCounter';
import { ENTITY_MANIFEST } from '@mummssoftware/global-context/PNCounter/constants';
import { isUserImpersonating } from '@mummssoftware/utils/auth';
import {
  Edit,
  Delete,
  View,
  FAJITA,
  STRING_TRUE,
} from '@mummssoftware/utils/constants';
import { ConfirmModal } from '@mummssoftware/common-ui';
import { GlobalContext, SET_FAJITA_FORM } from '@mummssoftware/global-context';
import { CellDiv } from '../../components/layout/WrapperDiv';
import { FormsContext } from '../../context';
import { FORM_NAME } from '../Form/constants';
import defaults from '../../translations/en.json';

export const CreatedByCell = React.memo((props: any) => {
  const {
    createpersonfirstname,
    createpersoncredentials,
    createpersonlastname,
  } = props.data;
  const credential = createpersonlastname
    ? `${createpersonfirstname} ${createpersonlastname}, ${createpersoncredentials}`
    : '';
  return <CellDiv>{credential}</CellDiv>;
});

export const EditCellRenderer = React.memo((props: any) => {
  const { agency, currentUser, deleteManifestForm } = useContext(FormsContext);
  const globalContext = useContext(GlobalContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOption, setModalOption] = useState<boolean>(false);

  const formData = props.data;

  const isUser = currentUser.personNumber === formData.createpersonnumber;
  const hasPerms =
    currentUser.isHospiceAdmin || isUser || isUserImpersonating(currentUser);
  const cellOptions = hasPerms ? [Edit, Delete, View] : [View];

  const readOnlyViewPossible =
    formData && (formData as any).formisreadonlyfullallowed === STRING_TRUE;

  const onClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (event: any) => {
    // stop propagation of panel expansion
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleDeleteOption = () => {
    deleteManifestForm(formData, agency as string);
    setAnchorEl(null);
  };

  const handleEditOption = () => {
    // this is to match what <FajitaForm /> for Patient is expected
    formData.isInProgressFAJITA = true;
    formData.isPrintViewFAJITA = false;
    formData.isReadOnlyViewFAJITA = false;

    // backend call form and patientmanifest
    formData.patientmanifest_id = formData.id;
    globalContext.dispatch({
      type: SET_FAJITA_FORM,
      payload: formData as mumms.FajitaForm,
    });
    const formName = `${FAJITA}:${formData.formkey}`;
    localStorage.setItem(FORM_NAME, formName);
    setAnchorEl(null);
  };

  const handleViewOption = () => {
    formData.isInProgressFAJITA = false;
    if (readOnlyViewPossible) {
      formData.isReadOnlyViewFAJITA = true;
      formData.isPrintViewFAJITA = false;
    } else {
      formData.isReadOnlyViewFAJITA = false;
      formData.isPrintViewFAJITA = true;
    }

    // backend call form and patientmanifest
    formData.patientmanifest_id = formData.id;
    globalContext.dispatch({
      type: SET_FAJITA_FORM,
      payload: formData as mumms.FajitaForm,
    });
    const formName = `${FAJITA}:${formData.formkey}`;
    localStorage.setItem(FORM_NAME, formName);
    setAnchorEl(null);
  };

  const selectOption = (option: string) => {
    switch (option) {
      case Edit:
        return handleEditOption();
      case Delete:
        return setModalOption(true);
      case View:
        return handleViewOption();
      default:
        return null;
    }
  };

  const onCancelClick = () => {
    setAnchorEl(null);
    setModalOption(false);
  };

  const onClickDelete = () => {
    handleDeleteOption();
    setModalOption(false);
  };

  const getMenuUI = () =>
    modalOption ? (
      <ConfirmModal
        onOKClick={onClickDelete}
        onCancelClick={onCancelClick}
        okText={defaults.yes}
        noText={defaults.no}
        modalText={defaults.confirmDelete}
      />
    ) : (
      <>
        {cellOptions.map((option: string) => (
          <MenuItem
            key={option}
            onClick={() => selectOption(option)}
            id="cross-form-edit"
          >
            {option}
          </MenuItem>
        ))}
      </>
    );

  return (
    <CellDiv>
      <IconButton onClick={handleEdit} size="small" disabled={false}>
        <SettingsIcon />
      </IconButton>
      <Fragment>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
          <div>{getMenuUI()}</div>
        </Menu>
      </Fragment>
    </CellDiv>
  );
});

export const NoteCountCellRenderer = (props: any) =>
  props?.data?.id && (
    <PNCounterIcon
      patientNumber={props?.data.patientnumber}
      // eslint-disable-next-line camelcase
      entityKey={props?.data?.id.toString()}
      // eslint-disable-next-line camelcase
      entityName={props?.data?.formname}
      entityType={ENTITY_MANIFEST}
    />
  );
